<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import VehicleDwellTimePageTable from './VehicleDwellTimePageTable'
const { CrudLayoutSearch } = JtCrud

@Component({
  name: 'VehicleDwellTime',
  mixins: [CrudLayoutSearch],
  components: {
    VehicleDwellTimePageTable
  }
})
class VehicleDwellTime extends Vue {
  get _pageTable () {
    return VehicleDwellTimePageTable
  }

  async actionButton (button, params, page) {
    await this.actionButtonDefault(button, { ...this.params, ...params }, page)
  }
}
export default VehicleDwellTime
</script>
<style lang="stylus" scoped></style>
